import React, { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setIsAdmin(false);
      setChecking(false);
      return;
    }
    api
      .get("/auth/verify")
      .then(() => setIsAdmin(true))
      .catch(() => {
        clearToken();
        setIsAdmin(false);
      })
      .finally(() => setChecking(false));
  }, []);

  const login = async (password) => {
    const { data } = await api.post("/auth/login", { password });
    setToken(data.token);
    setIsAdmin(true);
    return data;
  };

  const logout = () => {
    clearToken();
    setIsAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ isAdmin, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};
